export class NL_ProgramAyarlari{
    ID:number;
    CariListeSayisi:number;
    MalzemeListeSayisi:number;
    SatisFaturasiStoktanDusecekMi:number;  //1 ise evet 0 ise hayır
    fisyazicioto:number;
    FisYaziciAdi:string;
    BarkodYaziciAdi:string;
}


// WEBPACK FOOTER //
// ./src/models/NL_ProgramAyarlari.ts